module.exports = __webpack_public_path__ + "/img/Radial-Round-Labeled-szvzpz.svg";